const indexItems = [
  { id: 1, name: '动作冒险', count: '2,380部', icon: 'ri-sword-line' },
  { id: 2, name: '科幻奇幻', count: '1,560部', icon: 'ri-rocket-line' },
  { id: 3, name: '喜剧搞笑', count: '1,890部', icon: 'ri-emotion-laugh-line' },
  { id: 4, name: '悬疑惊悚', count: '1,420部', icon: 'ri-ghost-line' },
  { id: 5, name: '爱情剧情', count: '2,050部', icon: 'ri-heart-line' },
  { id: 6, name: '纪录纪实', count: '980部', icon: 'ri-film-line' },
  { id: 7, name: '动画动漫', count: '1,720部', icon: 'ri-palette-line' },
];

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-50 mb-3">
            片库索引
          </h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">
            按类型快速浏览海量片源，精准找到你想看的电影
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-7 gap-3 md:gap-4">
          {indexItems.map((item) => (
            <a
              key={item.id}
              href="#index"
              className="bg-background-100/80 rounded-lg p-4 md:p-5 border border-background-200/50 hover:border-primary-500/20 hover:bg-background-200/60 transition-all duration-200 group cursor-pointer text-center no-underline flex flex-col items-center gap-3"
            >
              <div className="w-12 h-12 rounded-xl bg-primary-500/10 flex items-center justify-center group-hover:bg-primary-500/15 transition-colors">
                <i className={`${item.icon} text-primary-500 text-xl`}></i>
              </div>
              <div>
                <h3 className="text-sm font-semibold text-foreground-200 group-hover:text-primary-400 transition-colors whitespace-nowrap">
                  {item.name}
                </h3>
                <p className="text-xs text-foreground-600 mt-0.5">{item.count}</p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}